import { createI18n } from 'vue-i18n';
import bgLocale from '../i18n/bg.json';

const i18n = createI18n({
  legacy: false,
  locale: 'bg',
  messages: {
    bg: bgLocale,
  },
});

export default i18n;
